import request from '@/router/axios';

const screenApi = '/api/twin/emergency-plan-screen'

// 去重查询

export const getDetail = (id) => {
    return request({
        url: '/api/produce/transport-plan/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
// 新增完整应急预案信息
export const add = (data) => {
    return request({
        url: '/api/produce/emergency-plan/insert-detail',
        method: 'post',
        data
    })
}

// 修改完整应急预案信息
export const update = (data) => {
    return request({
        url: '/api/produce/emergency-plan/update-detail',
        method: 'post',
        data
    })
}

// 查询完整应急预案详情
export const selectDetail = (id) => {
    return request({
        url: `/api/produce/emergency-plan/select-detail/id?id=${id}`,
        method: 'get',
    })
}
// 审核应急预案

export const audit = (data) => {
    return request({
        url: '/api/produce/emergency-plan/audit',
        method: 'post',
        data
    })
}

// 修订当前预案
export const revise = (data) => {
    return request({
        url: '/api/produce/emergency-plan/revise',
        method: 'get',
        params:data
    })
}



// 删除当前信息
export const remove = (id) => {
    return request({
        url: `/api/produce/emergency-plan/delete/id`,
        method: 'get',
        params: {
            id
        }
    })
}





export const getList = (params) => {
    return request({
        url: '/api/produce/emergency-plan/select/distinct/page',
        method: 'get',
        params
    })
}


export const getContractExtpage = (params) => {
    return request({
        url: '/api/produce/transport-contract-ext/select/contractExtpage',
        method: 'get',
        params
    })
}
export const getContractList = (params) => {
    return request({
        url: '/api/produce/transport-contract-ext/select/contractExtpage',
        method: 'get',
        params
    })
}



// 获取应急标签列表（通用）
export const getTitleList = (data) => {
    return request({
      url: "/api/produce/emergency-tag/select/page",
      method: "post",
      data,
    });
  };

  // 获取应急物资列表
  // 获取应急物资列表（去重分页）
export const getDistinctList = (data) => {
    return request({
      url: '/api/produce/emergency-material/select/page',
      method: 'post',
      data,
    });
  };

  // 获取应急专家列表（分页）
export const getExpertList = (data) => {
    return request({
      url: "/api/produce/emergency-expert/select/page",
      method: "post",
      data,
    });
  };


// 获取用户

export const getUserList = () => {
    return request({
        url: "/api/produce/blade-user/select/userList",
        method: "post",
        params: {},
    });
};

export const parseScreenFile = (data) => {
    return request({
        url: `${screenApi}/parse`,
        method: 'post',
        data
    })
}

export const getScreenExtractResult = (params) => {
    return request({
        url: `${screenApi}/extract-result`,
        method: 'get',
        params
    })
}

export const saveScreenExtractResult = (data) => {
    return request({
        url: `${screenApi}/extract-result/save`,
        method: 'post',
        data
    })
}

export const previewScreenFile = (params) => {
    return request({
        url: `${screenApi}/file/preview`,
        method: 'get',
        params
    })
}

export const displayScreenResult = (params) => {
    return request({
        url: `${screenApi}/display`,
        method: 'get',
        params
    })
}
